import { Box, Dialog, DialogTitle } from '@mui/material';
import { useProfileStyles } from '../styles';
import { Button } from '@uplift/ui-v2';

export type DeleteResourceModalProps = {
  title: string;
  cancelButtonText?: string;
  onClose: (shouldDelete: boolean) => void;
};

export const DeleteResourceModal: React.VFC<DeleteResourceModalProps> = props => {
  const { classes } = useProfileStyles();

  return (
    <Dialog open onClose={() => props.onClose(false)} maxWidth="xs" fullWidth>
      <DialogTitle className={classes.textAlignCenter}>{props.title}</DialogTitle>
      <Box p={2} className={classes.deleteModalActions}>
        <Button color="inherit" onClick={() => props.onClose(false)}>{props.cancelButtonText ?? 'Cancel'}</Button>
        <Button variant="contained" className={classes.deleteButton} onClick={() => props.onClose(true)}>Delete</Button>
      </Box>
    </Dialog>
  );
};
